export default __webpack_public_path__ + "static/media/arrow-open.99252238.svg";